<h2 class="pb-[2.5rem]">
  {{ 'personalizedJourney.landingPage.title' | transloco }}
</h2>

<div class="flex flex-col mb-20">

  <div
    class="flex justify-between mb-4 bg-white rounded-xl"
  >
    <div
      class="flex flex-col gap-[1.5rem] md:justify-between p-[2.5rem]"
    >
      <h4 class="flex items-center gap-4">
        <icon [name]="'thunder'" [size]="'1.5625rem'"></icon> {{
        'personalizedJourney.landingPage.journeyGoals' | transloco }}
      </h4>
      <p>
        <span>
          {{
          'personalizedJourney.landingPage.personalizedJourneyDescriptionTextPart1'
          | transloco }}
        </span>
        <span class="!font-bold">
          {{
          'personalizedJourney.landingPage.personalizedJourneyDescriptionTextPart2'
          | transloco }}
        </span>
        <span>
          {{
          'personalizedJourney.landingPage.personalizedJourneyDescriptionTextPart3'
          | transloco }}
        </span>
        <span class="!font-bold">
          {{
          'personalizedJourney.landingPage.personalizedJourneyDescriptionTextPart4'
          | transloco }}
        </span>
        <span>
          {{
          'personalizedJourney.landingPage.personalizedJourneyDescriptionTextPart5'
          | transloco }}
        </span>
        <span class="!font-bold">
          {{
          'personalizedJourney.landingPage.personalizedJourneyDescriptionTextPart6'
          | transloco }}
        </span>
        <span>
          {{
          'personalizedJourney.landingPage.personalizedJourneyDescriptionTextPart7'
          | transloco }}
        </span>
        <span class="!font-bold">
          {{
          'personalizedJourney.landingPage.personalizedJourneyDescriptionTextPart8'
          | transloco }}
        </span>
        <span>
          {{
          'personalizedJourney.landingPage.personalizedJourneyDescriptionTextPart9'
          | transloco }}
        </span>
        <span class="!font-bold">
          {{
          'personalizedJourney.landingPage.personalizedJourneyDescriptionTextPart10'
          | transloco }}
        </span>
        <span>
          {{
          'personalizedJourney.landingPage.personalizedJourneyDescriptionTextPart11'
          | transloco }}
        </span>
        <span class="!font-bold">
          {{
          'personalizedJourney.landingPage.personalizedJourneyDescriptionTextPart12'
          | transloco }}
        </span>
        <span>
          {{
          'personalizedJourney.landingPage.personalizedJourneyDescriptionTextPart13'
          | transloco }}
        </span>
      </p>
    </div>
  </div>

  <app-button
    [text]="'personalizedJourney.landingPage.buttonText' | transloco"
    [variant]="'secondary'"
    [icon]="'arrow-right'"
    (buttonClick)="accessJourneySearchPage()"
    class="md:self-end"
  ></app-button>
</div>
